import { Modal, message } from "antd";
import React, { Component } from "react";
import { MdCheckCircle } from "react-icons/md";
import { connect } from "react-redux";
import { pickDoneThunk } from "../../../../../redux/TOThunks/Action";
import { TaskIdCheck } from "../../../components/TaskIdCheck/TaskIdCheck";

export class DonePicking extends Component {
  state = {
    pickingDoneModal: false,
  };

  pickDoneCall = () => {
    this.props.loading(true);

    let taskId = localStorage.getItem("taskId");

    if (TaskIdCheck) {
      this.props
        .pickDoneThunk({
          access_token: this.props.access_token,
          taskId: taskId,
        })
        .then(() => {
          this.setState({ pickingDoneModal: false });
          this.props.loading(false);

          if (this.props.TOReducer?.PickDoneErr) {
            message.error(this.props.TOReducer?.PickDoneErr);
          } else {
            localStorage.removeItem("taskId");
            localStorage.removeItem("selectedBin");
            message.success(this.props.TOReducer?.PickDoneData);

            setTimeout(() => {
              this.props.history.push("/to-bin-racker");
            }, 2000);

            // this.props.getTaskId();
          }
        });
    }
  };

  render() {
    return (
      <>
        <button
          className="bbtn submitBtn"
          onClick={() =>
            this.setState({
              pickingDoneModal: true,
            })
          }
        >
          <MdCheckCircle />
          Done Picking
        </button>

        <Modal
          title={`Confirm Picking done ?`}
          open={this.state.pickingDoneModal}
          centered
          onOk={() => this.pickDoneCall()}
          onCancel={() => this.setState({ pickingDoneModal: false })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

const mapDispatchToProps = { pickDoneThunk };

export default connect(mapStateToProps, mapDispatchToProps)(DonePicking);
